function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container, List, Option, NoResultDefaultComponent } from './elements';
import SearchBar from './SearchBar';
import { CheckboxOption, RadioOption, SimpleOption } from './Options';

var OptionsList = /*#__PURE__*/function (_PureComponent) {
  _inherits(OptionsList, _PureComponent);

  var _super = _createSuper(OptionsList);

  function OptionsList() {
    var _this;

    _classCallCheck(this, OptionsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      searchTerm: '',
      searchItems: []
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (term) {
      var _this$props = _this.props,
          searchMethod = _this$props.searchMethod,
          options = _this$props.options;
      if (!searchMethod) return;
      var items = searchMethod({
        options: options,
        term: term
      });

      _this.setState({
        searchTerm: term,
        searchItems: items
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAll", function () {
      var _this$props2 = _this.props,
          values = _this$props2.values,
          options = _this$props2.options,
          onChange = _this$props2.onChange;

      if (options.length === values.length) {
        onChange([]);
      } else {
        onChange(options.map(function (option) {
          return option.value;
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var _this$props3 = _this.props,
          values = _this$props3.values,
          allowMultiple = _this$props3.allowMultiple,
          onChange = _this$props3.onChange;
      var nextValues = values;

      if (!allowMultiple) {
        nextValues = [value];
      } else if (values.includes(value)) {
        nextValues = values.filter(function (v) {
          return v !== value;
        });
      } else {
        nextValues = [].concat(_toConsumableArray(values), [value]);
      }

      onChange(nextValues);
    });

    return _this;
  }

  _createClass(OptionsList, [{
    key: "renderNoResult",
    value: function renderNoResult() {
      var _this$props4 = this.props,
          NoResult = _this$props4.NoResult,
          options = _this$props4.options;
      var _this$state = this.state,
          searchTerm = _this$state.searchTerm,
          searchItems = _this$state.searchItems;

      if (!searchTerm || searchItems.length > 0) {
        return null;
      } else if (typeof NoResult === 'function') {
        // Allow passing a component as NoResult
        return /*#__PURE__*/React.createElement(NoResult, {
          term: searchTerm,
          setTerm: this.onSearch,
          options: options
        });
      } else {
        return /*#__PURE__*/React.createElement(NoResultDefaultComponent, null, NoResult);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          allowMultiple = _this$props5.allowMultiple,
          className = _this$props5.className,
          OptionComponent = _this$props5.OptionComponent,
          options = _this$props5.options,
          searchPlaceholder = _this$props5.searchPlaceholder,
          searchMethod = _this$props5.searchMethod,
          toggleAllLabel = _this$props5.toggleAllLabel,
          values = _this$props5.values;
      var _this$state2 = this.state,
          searchTerm = _this$state2.searchTerm,
          searchItems = _this$state2.searchItems;
      var items = searchTerm ? searchItems : options;
      var ListItem = OptionComponent || (allowMultiple ? CheckboxOption : RadioOption);
      var shouldDisplayToggleAll = searchTerm.length === 0 && allowMultiple && toggleAllLabel && toggleAllLabel.length > 0;
      var selectedOptions = new Set(values);
      return /*#__PURE__*/React.createElement(Container, {
        className: className
      }, searchMethod && /*#__PURE__*/React.createElement(SearchBar, {
        placeholder: searchPlaceholder,
        onChange: this.onSearch,
        value: searchTerm
      }), /*#__PURE__*/React.createElement(List, null, shouldDisplayToggleAll && /*#__PURE__*/React.createElement(ListItem, {
        key: "toggle-all",
        label: toggleAllLabel,
        onChange: this.toggleAll,
        value: "",
        values: values,
        isSelected: values.length === options.length
      }), items.map(function (_ref) {
        var value = _ref.value,
            label = _ref.label,
            disabled = _ref.disabled;
        return /*#__PURE__*/React.createElement(ListItem, {
          key: value,
          value: value,
          disabled: disabled,
          label: label,
          onChange: _this2.handleChange,
          isSelected: selectedOptions.has(value)
        });
      })), this.renderNoResult());
    }
  }]);

  return OptionsList;
}(PureComponent);

var array = PropTypes.array,
    bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    oneOfType = PropTypes.oneOfType,
    string = PropTypes.string;
/**
 *
 * PropTypes validation
 */

OptionsList.propTypes = {
  /**
   * is checkboxes or radios ?
   */
  allowMultiple: bool,

  /**
   * ClassName needed by styled components
   */
  className: string,

  /**
   * Component to display when no result is found
   */
  NoResult: oneOfType([func, node, string]),

  /**
   * Array of options with value and label
   */
  options: array.isRequired,

  /**
   *
   */
  onChange: func,

  /**
   *
   */
  OptionComponent: PropTypes.elementType,

  /**
   * SearchBar input placeholder
   */
  searchPlaceholder: string,

  /**
   * Method used to search in the options
   */
  searchMethod: func,

  /**
   * Select all string
   */
  toggleAllLabel: string,

  /**
   * Selected values
   */
  values: array.isRequired
};
/**
 * Default props
 */

OptionsList.defaultProps = {
  className: '',
  NoResult: null,
  onChange: function onChange() {},
  allowMultiple: false,
  searchPlaceholder: '',
  searchMethod: null,
  toggleAllLabel: null,
  OptionComponent: null
};
OptionsList.Option = Option;
OptionsList.CheckboxOption = CheckboxOption;
OptionsList.RadioOption = RadioOption;
OptionsList.SimpleOption = SimpleOption;
export default OptionsList;